export interface VeeWalletState {
	fetchStatus: RequestStatus;
	depositAddress: string;
	vee: string;
	usd: string;
	fqdn: string;
}

const INITIAL_VEE_WALLET_STATE: VeeWalletState = {
	fetchStatus: "",
	depositAddress: "",
	vee: "",
	usd: "",
	fqdn: ""
};

export default (state: VeeWalletState = INITIAL_VEE_WALLET_STATE, action: any): VeeWalletState => {
	switch (action.type) {
		case "CURRENT_USER/LOGGED_OUT": {
			return {...INITIAL_VEE_WALLET_STATE};
		}

		case "VEE_WALLET/GET_WALLET/PENDING": {
			return {
				...state,
				fetchStatus: "pending",
			};
		}

		case "VEE_WALLET/GET_WALLET/SUCCESS": {
			return {
				...state,
				fetchStatus: "success",
				depositAddress: action.data.depositAddress,
				vee: action.data.vee,
				usd: action.data.usd,
				fqdn: action.data.fqdn
			};
		}

		case "VEE_WALLET/GET_WALLET/FAILURE": {
			return {
				...state,
				fetchStatus: "failure",
			};
		}
	}

	return state;
};

// helper to get this reducer's state as a typed value
const veeWalletState = state => state.veeWallet as VeeWalletState;

export const selectors = {
	selectWalletFetchStatus: state => veeWalletState(state).fetchStatus,
	selectWalletDepositAddress: state => veeWalletState(state).depositAddress,
	selectWalletVeeBalance: state => veeWalletState(state).vee,
	selectWalletUsdBalance: state => veeWalletState(state).usd,
	selectWalletFqdn: state => veeWalletState(state).fqdn,
};
